export default {
 TOOLTIP:'Warrants give investors the right to buy a fixed number of shares at a fixed price, on a future date. Find out more about about warrants.  '
}